import { getInitials, getAvatarColor } from '../../utils/chat/format';

function Avatar({
  name, size = 9, online, square = false,
}: { name?: string; size?: number; online?: boolean; square?: boolean }) {
  const n = name || '?';
  const initials = getInitials(n);
  const color = getAvatarColor(n);
  const px = size * 4; // Tailwind unit → pixels (1 unit = 4px)
  const rounded = square ? 'rounded-xl' : 'rounded-full';

  return (
    <div className="relative flex-shrink-0" style={{ width: px, height: px }}>
      <div
        className={`bg-gradient-to-br ${color} ${rounded} flex items-center justify-center text-white font-semibold select-none shadow-sm w-full h-full ${online ? 'ring-2 ring-white' : ''}`}
        style={{ fontSize: size < 8 ? 10 : size < 10 ? 12 : 14 }}>
        {initials}
      </div>
      {online !== undefined && (
        <span
          className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 shadow-sm ${online ? 'gc-online-dot' : ''}`}
          style={{
            borderColor: 'var(--gc-surface-0)',
            background: online ? 'var(--gc-online)' : 'var(--gc-offline)',
          }}
        />
      )}
    </div>
  );
}

export default Avatar;
